/**
 * The days of the week
 * {@docCategory DateTimeUtilities}
 */
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

/**
 * The months
 * {@docCategory DateTimeUtilities}
 */
export enum MonthOfYear {
  January = 0,
  February = 1,
  March = 2,
  April = 3,
  May = 4,
  June = 5,
  July = 6,
  August = 7,
  September = 8,
  October = 9,
  November = 10,
  December = 11,
}

/**
 * First week of the year settings types
 * {@docCategory DateTimeUtilities}
 */
export enum FirstWeekOfYear {
  FirstDay = 0,
  FirstFullWeek = 1,
  FirstFourDayWeek = 2,
}

/**
 * The supported date range types
 * {@docCategory DateTimeUtilities}
 */
export enum DateRangeType {
  Day = 0,
  Week = 1,
  Month = 2,
  WorkWeek = 3,
}

export const DAYS_IN_WEEK = 7;
